import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APP_CONSTANTS } from 'src/app/core/constant/constants';
import { JobOfferBasicResult } from 'src/app/shared/model/job-offer-result';
import { ShortNumberPipe } from 'src/app/shared/pipe/shor-number.pipe';
import { SolesCurrencyPipe } from 'src/app/shared/pipe/soles-currency.pipe';
import { TimeAgoPipe } from 'src/app/shared/pipe/time-ago.pipe';

@Component({
  selector: 'app-job-card',
  imports: [CommonModule, RouterModule, TimeAgoPipe, SolesCurrencyPipe, ShortNumberPipe],
  templateUrl: './job-card.component.html',
})
export class JobCardComponent {
  @Input() job!: JobOfferBasicResult;

  companyImage(job: JobOfferBasicResult): string {
    const url = job.companyUrlBannerMini;
    if (!url || url.trim() === '') {
      return APP_CONSTANTS.DEFAULT_IMAGE_COMPANY;
    }
    return url;
  }

  companyBanner(job: JobOfferBasicResult): string {
    const url = job.companyUrlBannerMvv;
    if (!url || url.trim() === '') {
      return APP_CONSTANTS.DEFAULT_BANNER_COMPANY;
    }
    return url;
  }

  ShowSalary(job: JobOfferBasicResult): boolean {
    if (job.showSalary === '1') {
      return true;
    } else {
      return false;
    }
  }
}
